const firebaseConfig = {
  apiKey: 'AIzaSyBoDnoeuVZhume65J8tUAGqzsgoTAiZ6E4',
  authDomain: 'track-panel-vuejs.firebaseapp.com',
  databaseURL: 'https://track-panel-vuejs.firebaseio.com',
  projectId: 'track-panel-vuejs',
  storageBucket: 'track-panel-vuejs.appspot.com',
  messagingSenderId: '1048927688761',
  appId: '1:1048927688761:web:e9e8a0bb8295d5d927d5e8',
  measurementId: 'G-8QEXP85LH7',
}

export default firebaseConfig
